function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaymentCreditCardRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 16v9h24v-9h2v9c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-9h2zm3.5 4a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 017.5 20zm5 0a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0112.5 20zM28 5c1.1 0 2 .9 2 2v7H2V7c0-1.1.9-2 2-2h24zM4 10h24V7H4v3z",
    fill: props.color
  }));
}

export default SvgIconPaymentCreditCardRexOutline;